export function generateHeader(authValue , file = false) {
    var headers= {
        Token: localStorage.getItem('token'),
        Authkey: authValue,
    }
    if(file){
        Object.assign(headers, {'Content-Type': 'multipart/form-data'})
    }
    return headers
}

export function handleFileType(allowed_type , file_type){
    if(allowed_type.includes(file_type)){
        return "true"
    }
    return "false"
}

export function handleFileSize(allow_size , size) {
    if(size <= allow_size)
    {
        return "true"
    }
    return "false"
}
// Array
export function maritalStatusData(){
    var marital_status = [
        "Married",
        "Unmarried"
    ]

    return marital_status
}

export function genderData(){
    var gender = [
        "Male",
        "Female"
    ]

    return gender
}

